import {
  RIDE_WITH_ROUTE_BY_TRIP_ID,
  FETCH_RIDES_FOR_VEHICLE,
  RIDES_LOADING,
} from '../actions/rides';

export default function(state = {}, action) {
  switch (action.type) {
    case RIDES_LOADING:
      return { ...state, isLoading: !!action.payload };
    case FETCH_RIDES_FOR_VEHICLE: {
      return {
        ...state,
        currentVehicleRides: action.payload.rides,
      };
    }
    case RIDE_WITH_ROUTE_BY_TRIP_ID: {
      const { rides, tripId } = action.payload;
      return { ...state, [tripId]: rides };
    }
    default:
      return { ...state };
  }
}
